import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NavigationToggle from "../../UI/NavigationToggle/NavigationToggle";
import NavigationItems from "../NavigationItems//NavigationItems";
import ThemeSwitch from '../../ThemeSwitch/ThemeSwitch';
import classes from "./SideNavigation.scss";

import { hideSideNavigation } from '../../../store/actions/index';

class sideNavigation extends Component {

  state = {
    sideNavigationActive: false
  };

  mouseEnterHandler = () => {
    this.setState(prevState => {
      return { sideNavigationActive: !prevState.sideNavigationActive }
    });
  };

  mouseLeavehandler = () => {
    if(this.props.location.pathname.trim('').includes('/flights/search')) {
      this.props.onHideSideNavigation();
    }
    this.setState(prevState => {
      return { sideNavigationActive: !prevState.sideNavigationActive }
    })
  };

  render() {
    let sideNavigationClass = [classes.SideNavigation];

    if (window.innerWidth > 600) {
      if (this.props.toggleNavigation === true) {
        if (sideNavigationClass.includes(classes.SideNavDisabled)) {
          sideNavigationClass.pop(classes.sideNavigationDisabled);
        }
        if (!this.props.isLoggedIn) sideNavigationClass.push(classes.SideNavActive);
      } else if (this.props.toggleNavigation === false) {
        sideNavigationClass.push(classes.SideNavDisabled);
      }
    } else {
      if (this.props.mToggleNavigation === true) {
        if (sideNavigationClass.includes(classes.SideNavDisabled)) {
          sideNavigationClass.pop(classes.sideNavigationDisabled);
        }
        sideNavigationClass.push(classes.SideNavActive);
      } else if (this.props.mToggleNavigation === false) {
        sideNavigationClass.push(classes.SideNavDisabled);
      }
    }

    return (
      <React.Fragment>
        <div
          className={sideNavigationClass.join(" ")}
          onMouseEnter={this.mouseEnterHandler}
          onMouseLeave={this.mouseLeavehandler}>
          <div>
            <div className={`mb-10`}>
              <div className="pl-2">
                <NavigationToggle type='light' />
              </div>
            </div>
            <nav>
              <NavigationItems
                navigationItemsActive={this.state.sideNavigationActive}
              />
            </nav>
          </div>
          <ThemeSwitch />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    toggleNavigation: state.navigation.sideNavigation,
    mToggleNavigation: state.navigation.mSideNavigation,
    isLoggedIn: state.auth.isLoggedIn
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onHideSideNavigation: () => dispatch(hideSideNavigation())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(sideNavigation));



// WEBPACK FOOTER //
// ./src/components/Navigation/SideNavigation/SideNavigation.js